import styled from 'styled-components';
import { Base } from 'styled';
import { Props } from './index';

type ContainerProps = Pick<Props, 'showError' | 'color'>;

type LabelProps = {
  showAsPlaceholder?: boolean;
};

type ErrorMessageProps = LabelProps & {
  showError: boolean;
};

export const Label = styled(Base)<LabelProps>`
  ${({ theme }) => theme.typography.variants.primary.xs};
  ${({ theme }) => theme.transitions['transition-short']};
  margin-top: ${({ showAsPlaceholder }) => showAsPlaceholder && '-1rem'};
  top: ${({ showAsPlaceholder }) => (!showAsPlaceholder ? '0.675rem' : '0rem')};
  margin-left: ${({ showAsPlaceholder }) =>
    showAsPlaceholder ? '0rem' : '0.75rem'};
  color: ${({ showAsPlaceholder, theme }) =>
    theme.colors[showAsPlaceholder ? 'black' : 'gray-dark']};
`;

export const ErrorMessageContainer = styled(Base)`
  display: flex;
  flex-direction: row-reverse;
`;

export const ErrorMessage = styled(Label)<ErrorMessageProps>`
  color: ${({ theme }) => theme.colors.red};
  opacity: ${({ showError }) => (showError ? 1 : 0)};
`;

export const Container = styled(Base).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['color'].includes(prop) && defaultValidatorFn(prop),
})<ContainerProps>`
  ${({ theme }) => theme.typography.variants.primary.xs};

  input,
  textarea {
    ${({ theme }) => theme.typography.variants.primary.xs};
    padding: 0.625rem 0.75rem;
    width: 100%;
    border: none;
    border-bottom: 1px solid
      ${({ showError, theme, color = 'gray' }) =>
        showError ? theme.colors.red : theme.colors[color]};
    background-color: ${({ theme }) => theme.colors.transparent};

    :focus {
      border-bottom-color: ${({ theme }) => theme.colors['blue-darker']};
    }
  }

  /* Overwrite label color if there is error */
  label {
    color: ${({ showError, theme }) => showError && theme.colors.red};
  }

  /* Removes autofill background color */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }

  ${({ theme, color }) =>
    color &&
    `
    input,
    textarea {
      color: ${theme.colors[color]};
    }

    input:-webkit-autofill {
      color: ${theme.colors[color]} !important;
      -webkit-text-fill-color: ${theme.colors[color]} !important;
    }
  `}
`;

export const TextFieldContainer = styled(Base).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !['display', 'width'].includes(prop) && defaultValidatorFn(prop),
})``;
